import type { IconData } from '@stacksjs/iconify-core'

export const sadFaceRemix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.75 24C4.75 13.369 13.369 4.75 24 4.75S43.25 13.369 43.25 24S34.632 43.25 24 43.25S4.75 34.632 4.75 24M24 .75C11.16.75.75 11.16.75 24S11.16 47.25 24 47.25S47.25 36.84 47.25 24S36.84.75 24 .75M17.5 17a2.5 2.5 0 0 0-5 0v2a2.5 2.5 0 0 0 5 0zm13 0a2.5 2.5 0 0 1 5 0v2a2.5 2.5 0 0 1-5 0zM24 29.5a5.5 5.5 0 0 0-5.5 5.5a2.5 2.5 0 0 1-5 0c0-5.799 4.701-10.5 10.5-10.5S34.5 29.201 34.5 35a2.5 2.5 0 0 1-5 0a5.5 5.5 0 0 0-5.5-5.5\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default sadFaceRemix
